
(() => {
  if (window.soPeachyGiftNotesLoaded) return;
  window.soPeachyGiftNotesLoaded = true;

  const timers = new WeakMap();
  const saving = new WeakSet();

  async function saveGiftNote(field) {
    if (!field.isConnected || saving.has(field)) return;

    const key = field.dataset.lineKey;
    const message = field.value.trim();
    const status = field.parentElement.querySelector(
      '.so-peachy-gift-note__status'
    );

    if (!key) return;

    saving.add(field);
    field.dataset.saving = 'true';
    if (status) status.textContent = 'Saving...';

    try {
      const cartResponse = await fetch('/cart.js');
      if (!cartResponse.ok) throw new Error('Cart unavailable');

      const cart = await cartResponse.json();
      const item = cart.items.find((line) => line.key === key);

      if (!item) throw new Error('Product no longer in cart');

      const properties = { ...item.properties };

      if (message) {
        properties['Gift message'] = message;
      } else {
        delete properties['Gift message'];
      }

      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: key,
          properties
        })
      });

      if (!response.ok) throw new Error('Could not save message');

      const updatedCart = await response.json();
      const updatedItem = updatedCart.items.find(
        (line) =>
          line.variant_id === item.variant_id &&
          line.properties?.['Gift message'] === message
      );

      if (updatedItem) {
        field.dataset.lineKey = updatedItem.key;
      }

      if (status) status.textContent = 'Gift message saved';
    } catch (error) {
      console.error('SŌ PEACHY gift note:', error);
      if (status) {
        status.textContent = 'Could not save. Please try again.';
      }
    } finally {
      saving.delete(field);
      delete field.dataset.saving;
    }
  }

  document.addEventListener('input', (event) => {
    const field = event.target;

    if (
      !(field instanceof HTMLTextAreaElement) ||
      !field.matches('.so-peachy-gift-note__input')
    ) {
      return;
    }

    clearTimeout(timers.get(field));

    timers.set(
      field,
      setTimeout(() => saveGiftNote(field), 700)
    );
  });
})();
